import { createFileRoute } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/coach/_backend/edit-profile/offers")({
  head: () => ({
    meta: [{ title: "Offers – Dream Coach Match" }],
  }),
  component: OffersLayout,
});

function OffersLayout() {
  return <Outlet />;
}
